// import { WindmillContext } from "@windmill/react-ui";
// import CardItem from "components/dashboard/CardItem";
// import CardItemTwo from "components/dashboard/CardItemTwo";
// import PageTitle from "components/Typography/PageTitle";
// import { SidebarContext } from "context/SidebarContext";
// import * as dayjs from "dayjs";
// import isBetween from "dayjs/plugin/isBetween";
// import isToday from "dayjs/plugin/isToday";
// import isYesterday from "dayjs/plugin/isYesterday";
// import useAsync from "hooks/useAsync";
// import useFilter from "hooks/useFilter";
// import { useContext, useEffect, useState, useRef } from "react";
// import { useTranslation } from "react-i18next";
// import { FiCheck, FiRefreshCw, FiShoppingCart, FiTruck } from "react-icons/fi";
// import { ImCreditCard, ImStack } from "react-icons/im";
// import OrderServices from "services/OrderServices";
// import socket from "services/SocketService";
// import ChatServices from "services/ChatServices";
// import { notifySuccess, notifyError } from "utils/toast";
// import { IoSendSharp } from "react-icons/io5";
// import Uploader from "components/image-uploader/UploaderChat";
// import { Modal, Button } from "@windmill/react-ui";
// import SelectState from "components/form/SelectStaffState";
// import SelectSingleState from "components/form/SelectSingleState";
// import { requestNotificationPermission, showBrowserNotification, setupPushNotifications } from "utils/browserNotify";
// import useSidebar from "routes/sidebar";
// import { useChatStatus } from "context/ChatStatusContext";
// import { BiSolidUserCircle } from "react-icons/bi";
// import { RxCross2 } from "react-icons/rx";
// import { TbBellRingingFilled } from "react-icons/tb";

// const Dashboard = () => {
//   const { globalSetting } = useFilter();
//   const { mode } = useContext(WindmillContext);

//   // Ask for browser notification permission once. Once granted, also
//   // subscribe to Web Push, so notifications still arrive even if the
//   // browser is fully closed later (not just minimized/another tab).
//   useEffect(() => {
//     requestNotificationPermission().then((granted) => {
//       if (granted) setupPushNotifications(ChatServices.savePushSubscription);
//     });
//   }, []);
//   const [showChat, setShowChat] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [openModel, setOpenModel] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");
//   const [typingUser, setTypingUser] = useState(null);
//   const [timeoutId, setTimeoutId] = useState();
//   const [imageUrl, setImageUrl] = useState();
//   const [chatId, setChatId] = useState();
//   const [agentId, setAgentId] = useState();
//   const [agentRefId, setAgentRefId] = useState()

//   const [stateId, setStateId] = useState(() => {
//     return localStorage.getItem("stateId") || null;
//   });

//   const [showReason, setShowReason] = useState(false);
//   const [receiverName, setReceiverName] = useState("");
//   const [rejectReason, setRejectReason] = useState("");
//   const [history, setHistory] = useState();
//   const [website, setWebsite] = useState();
//   const [subuserId, setSubuserId] = useState();
//   const [selectedEmp, setSelectedEmp] = useState();
//   const [openTransferModal, setOpenTransferModal] = useState(false);
//   const [selectedState, setSelectedState] = useState(null);

//   const [urgentActive, setUrgentActive] = useState(false);
//   const urgentActiveRef = useRef(false);
//   const [urgentTimeLeft, setUrgentTimeLeft] = useState(0);
//   const urgentIntervalRef = useRef(null);
//   const [chatEnded, setChatEnded] = useState(false);

//   // Confirmation popup for the header buttons: null | "alert" | "end"
//   const [confirmAction, setConfirmAction] = useState(null);

//   const { sidebar } = useSidebar();

//   const adminInfo = localStorage.getItem("adminInfo")
//     ? JSON.parse(localStorage.getItem("adminInfo"))
//     : null;

//   const id_employee = adminInfo?.id ? adminInfo.id : 0;
//   const senderName = adminInfo?.name;
//   const profile = adminInfo?.profile;

//   const [agentName, setAgentName] = useState(
//     localStorage.getItem("agentNameFChat")
//       ? localStorage.getItem("agentNameFChat")
//       : null
//   );

//   dayjs.extend(isBetween);
//   dayjs.extend(isToday);
//   dayjs.extend(isYesterday);

//   const { setNotification } = useContext(SidebarContext);

//   const [todayOrderAmount, setTodayOrderAmount] = useState(0);
//   const [yesterdayOrderAmount, setYesterdayOrderAmount] = useState(0);
//   const [salesReport, setSalesReport] = useState([]);
//   const [todayCashPayment, setTodayCashPayment] = useState(0);
//   const [todayCardPayment, setTodayCardPayment] = useState(0);
//   const [todayCreditPayment, setTodayCreditPayment] = useState(0);
//   const [yesterdayCashPayment, setYesterdayCashPayment] = useState(0);
//   const [yesterdayCardPayment, setYesterdayCardPayment] = useState(0);
//   const [yesterdayCreditPayment, setYesterdayCreditPayment] = useState(0);

//   const { data: dashboardOrderCount, loading: loadingOrderCount } = useAsync(
//     OrderServices.getDashboardCount
//   );

//   const { data: dashboardOrderAmount, loading: loadingOrderAmount } = useAsync(
//     OrderServices.getDashboardAmount
//   );

//   const currency = globalSetting?.default_currency || "$";

//   const { t } = useTranslation();

//   useEffect(() => {
//     socket.on("typing", ({ chatId, senderId, receiverId, senderName }) => {
//       setTypingUser(senderName);
//     });

//     socket.on("stop_typing", ({ chatId, senderId, receiverId, senderName }) => {
//       setTypingUser(null);
//     });

//     return () => {
//       socket.off("typing");
//       socket.off("stop_typing");
//     };
//   }, []);

//   useEffect(() => {
//     if (!stateId) {
//       console.log("No state selected, exiting useEffect.");
//       return;
//     }

//     const handleAvailableEmployees = ({ employees }) => {
//       const filteredEmployees = employees
//         .filter((emp) => Number(emp.id) !== Number(id_employee))
//         .sort((a, b) => b.is_online - a.is_online);

//       setUsers(filteredEmployees);
//     };

//     socket.on("available_employees", handleAvailableEmployees);

//     socket.emit("get_available_emp", {
//       state: stateId,
//       employeeId: id_employee,
//     });

//     return () => {
//       socket.off("available_employees", handleAvailableEmployees);
//     };
//   }, [stateId]);

//   useEffect(() => {
//     const todayOrder = dashboardOrderAmount?.ordersData?.filter((order) =>
//       dayjs(order.updatedAt).isToday()
//     );

//     const todayReport = todayOrder?.reduce(
//       (pre, acc) => pre + acc.total,
//       0
//     );

//     setTodayOrderAmount(todayReport);

//     const yesterdayOrder = dashboardOrderAmount?.ordersData?.filter((order) =>
//       dayjs(order.updatedAt).set(-1, "day").isYesterday()
//     );

//     const yesterdayReport = yesterdayOrder?.reduce(
//       (pre, acc) => pre + acc.total,
//       0
//     );

//     setYesterdayOrderAmount(yesterdayReport);

//     const salesOrderChartData = dashboardOrderAmount?.ordersData?.filter(
//       (order) =>
//         dayjs(order.updatedAt).isBetween(
//           new Date().setDate(new Date().getDate() - 7),
//           new Date()
//         )
//     );

//     salesOrderChartData?.reduce((res, value) => {
//       let onlyDate = value.updatedAt.split("T")[0];

//       if (!res[onlyDate]) {
//         res[onlyDate] = {
//           date: onlyDate,
//           total: 0,
//           order: 0,
//         };

//         salesReport.push(res[onlyDate]);
//       }

//       res[onlyDate].total += value.total;
//       res[onlyDate].order += 1;

//       return res;
//     }, {});

//     setSalesReport(salesReport);

//     const todayPaymentMethodData = [];
//     const yesterDayPaymentMethodData = [];

//     dashboardOrderAmount?.ordersData?.filter((item, value) => {
//       if (dayjs(item.updatedAt).isToday()) {
//         if (item.paymentMethod === "Cash") {
//           let cashMethod = {
//             paymentMethod: "Cash",
//             total: item.total,
//           };

//           todayPaymentMethodData.push(cashMethod);
//         }

//         if (item.paymentMethod === "Credit") {
//           const cashMethod = {
//             paymentMethod: "Credit",
//             total: item.total,
//           };

//           todayPaymentMethodData.push(cashMethod);
//         }

//         if (item.paymentMethod === "Card") {
//           const cashMethod = {
//             paymentMethod: "Card",
//             total: item.total,
//           };

//           todayPaymentMethodData.push(cashMethod);
//         }
//       }

//       return item;
//     });

//     dashboardOrderAmount?.ordersData?.filter((item, value) => {
//       if (dayjs(item.updatedAt).set(-1, "day").isYesterday()) {
//         if (item.paymentMethod === "Cash") {
//           let cashMethod = {
//             paymentMethod: "Cash",
//             total: item.total,
//           };

//           yesterDayPaymentMethodData.push(cashMethod);
//         }

//         if (item.paymentMethod === "Credit") {
//           const cashMethod = {
//             paymentMethod: "Credit",
//             total: item?.total,
//           };

//           yesterDayPaymentMethodData.push(cashMethod);
//         }

//         if (item.paymentMethod === "Card") {
//           const cashMethod = {
//             paymentMethod: "Card",
//             total: item?.total,
//           };

//           yesterDayPaymentMethodData.push(cashMethod);
//         }
//       }

//       return item;
//     });

//     const todayCsCdCit = Object.values(
//       todayPaymentMethodData.reduce((r, { paymentMethod, total }) => {
//         if (!r[paymentMethod]) {
//           r[paymentMethod] = {
//             paymentMethod,
//             total: 0,
//           };
//         }

//         r[paymentMethod].total += total;

//         return r;
//       }, {})
//     );

//     const today_cash_payment = todayCsCdCit.find(
//       (el) => el.paymentMethod === "Cash"
//     );

//     setTodayCashPayment(today_cash_payment?.total);

//     const today_card_payment = todayCsCdCit.find(
//       (el) => el.paymentMethod === "Card"
//     );

//     setTodayCardPayment(today_card_payment?.total);

//     const today_credit_payment = todayCsCdCit.find(
//       (el) => el.paymentMethod === "Credit"
//     );

//     setTodayCreditPayment(today_credit_payment?.total);

//     const yesterDayCsCdCit = Object.values(
//       yesterDayPaymentMethodData.reduce((r, { paymentMethod, total }) => {
//         if (!r[paymentMethod]) {
//           r[paymentMethod] = {
//             paymentMethod,
//             total: 0,
//           };
//         }

//         r[paymentMethod].total += total;

//         return r;
//       }, {})
//     );

//     const yesterday_cash_payment = yesterDayCsCdCit.find(
//       (el) => el.paymentMethod === "Cash"
//     );

//     setYesterdayCashPayment(yesterday_cash_payment?.total);

//     const yesterday_card_payment = yesterDayCsCdCit.find(
//       (el) => el.paymentMethod === "Card"
//     );

//     setYesterdayCardPayment(yesterday_card_payment?.total);

//     const yesterday_credit_payment = yesterDayCsCdCit.find(
//       (el) => el.paymentMethod === "Credit"
//     );

//     setYesterdayCreditPayment(yesterday_credit_payment?.total);
//   }, [dashboardOrderAmount]);

//   useEffect(() => {
//     if (!socket.connected) socket.connect();

//     const storedChatId = localStorage.getItem("chatId");
//     const storedAgentId = localStorage.getItem("agentId");
//     const storedReceiverName = localStorage.getItem("receiverName");
//     const storedStateId = localStorage.getItem("stateId");

//     const saveChatData = ({
//       chatId,
//       agentId,
//       state,
//       agentName,
//       agentRef
//     }) => {
//       setChatId(chatId);
//       setAgentId(agentId);
//       setAgentRefId(agentRef)
//       setStateId(state);
//       setReceiverName(agentName);

//       localStorage.setItem("chatId", chatId);
//       localStorage.setItem("agentId", agentId);
//       localStorage.setItem("stateId", state);
//       localStorage.setItem("receiverName", agentName);
//       localStorage.setItem("agentRefId", agentRefId)
//     };

//     const fetchAvailableEmployees = (stateIdToUse) => {
//       if (!stateIdToUse) return;

//       socket.emit("get_available_emp", {
//         state: stateIdToUse,
//         employeeId: id_employee,
//       });
//     };

//     const handleConnect = () => {
//       socket.emit("register", [
//         id_employee,
//         senderName,
//         "employee",
//         sessionStorage.getItem("isOnline") === "true",
//       ]);

//       socket.on(
//         "resume_chat",
//         ({ chatId, agentId, stateId, agentRef }) => {
//           setChatId(chatId);
//           setAgentId(agentId);
//           setAgentRefId(agentRef)
//           setShowChat(true);

//           fetchAvailableEmployees(stateId);

//           socket.emit("chat_list", {
//             chatId,
//             agentId,
//           });

//           localStorage.setItem("chatId", chatId);
//           localStorage.setItem("agentId", agentId);
//           localStorage.setItem("agentRefId", agentRefId);
//         }
//       );

//       if (
//         storedChatId &&
//         storedAgentId &&
//         storedReceiverName
//       ) {
//         setChatId(storedChatId);
//         setAgentId(storedAgentId);
//         setAgentRefId(storedAgentId)
//         setReceiverName(storedReceiverName);
//         setShowChat(true);

//         socket.emit("chat_list", {
//           chatId: storedChatId,
//           agentId: storedAgentId,
//         });
//       }
//     };

//     const handleChatHistory = ({ rows }) => {
//       if (rows) {
//         const formattedMessages = rows.map((msg) => ({
//           sender: msg.sender_name,
//           senderId: msg.sender_id,
//           receiverId: msg.receiver_id,
//           chatId: msg.chat_id,
//           text: msg.message,
//           type: msg.type,
//           time: msg.timestamp,
//         }));

//         setMessages(formattedMessages);
//       }
//     };

//     const handleNotification = (data) => {
//       setNotification((prev) => [...prev, data]);
//       showBrowserNotification(
//         data?.title || "B2B Cabs",
//         data?.message || "You have a new notification"
//       );
//     };

//     socket.on("connect", handleConnect);

//     if (socket.connected) {
//       handleConnect();
//     }

//     socket.on("get_chat", handleChatHistory);

//     socket.on("receiveNotification", handleNotification);

//     socket.on("new_customer", ({ chatId, agentId, state, agentName, agentRef }) => {
//       // console.log("[NEW CUSTOMER]", { chatId, agentId, agentName, state, timestamp: new Date().toISOString() });
//       console.log("New customer connected:", chatId, agentId, agentName, agentRef);
//       saveChatData({ chatId, agentId, state, agentName, agentRef });
//       fetchAvailableEmployees(storedStateId);
//       if (agentId) {
//         socket.emit("chat_list", { chatId, agentId });
//       }
//       showBrowserNotification(
//         "New chat assigned",
//         agentName ? `${agentName} is waiting for you` : "A customer is waiting for you"
//       );
//     });

//     socket.on(
//       "chat_transferred",
//       ({
//         chatId,
//         newEmployeeId,
//         oldEmployeeId,
//         agentId,
//         state,
//         agentName,
//         chatHistory,
//         agentRef
//       }) => {
//         const transformedMessages = chatHistory.map(
//           (msg) => ({
//             sender: msg.sender_name,
//             text: msg.message,
//             time: msg.timestamp,
//             type: msg.type,
//           })
//         );

//         setMessages((prev) => [...prev, ...transformedMessages]);
//         setShowChat(true);
//         saveChatData({ chatId, agentId, state, agentName, agentRef });
//       });

//     socket.on(
//       "send_status",
//       ({
//         agentId,
//         subuserId,
//         state,
//         website,
//         agentRef
//       }) => {
//         if (agentId && state && website) {
//           if (
//             sessionStorage.getItem("isOnline") ===
//             "true"
//           ) {
//             sendStatusDirect("accept", {
//               agentId,
//               subuserId,
//               state,
//               website,
//             });
//           } else {
//             setAgentId(agentId);
//             setAgentRefId(agentRef)
//             setStateId(state);
//             setWebsite(website);
//             setSubuserId(subuserId);
//             setOpenModel(true);
//           }
//         } else {
//           console.error(
//             "Cannot sendStatus, missing data",
//             {
//               agentId,
//               subuserId,
//               state,
//               website,
//             }
//           );
//         }
//       }
//     );

//     socket.on(
//       "receive_message",
//       ({
//         chatId: msgChatId,
//         senderId,
//         message,
//         type,
//         senderName,
//         timestamp,
//       }) => {
//         setMessages((prev) => [
//           ...prev,
//           {
//             sender: senderName,
//             text: message,
//             time: timestamp,
//             type,
//           },
//         ]);

//         showBrowserNotification(
//           senderName || "New message",
//           type === "text" ? message : `Sent ${type || "a file"}`
//         );

//         const currentChatId =
//           chatId ||
//           localStorage.getItem("chatId");

//         const currentAgentId =
//           agentId ||
//           localStorage.getItem("agentId");

//         if (
//           urgentActiveRef.current &&
//           currentChatId == msgChatId &&
//           senderId == currentAgentId
//         ) {
//           clearInterval(
//             urgentIntervalRef.current
//           );

//           urgentIntervalRef.current = null;

//           setUrgentActive(false);
//           urgentActiveRef.current = false;
//           setUrgentTimeLeft(0);
//         }
//       }
//     );


//     socket.on(
//       "chat_ended",
//       ({
//         chatId: endedChatId,
//         endedBy,
//         message,
//       }) => {
//         setShowChat(false);
//         setMessages([]);

//         localStorage.removeItem("chatId");
//         localStorage.removeItem("agentId");
//         localStorage.removeItem("stateId");
//         localStorage.removeItem(
//           "receiverName"
//         );
//       }
//     );

//     socket.emit("chat_list", {
//       chatId,
//       agentId,
//     });

//     return () => {
//       socket.off("connect", handleConnect);
//       socket.off(
//         "get_chat",
//         handleChatHistory
//       );

//       socket.off(
//         "receiveNotification",
//         handleNotification
//       );

//       socket.off("new_customer");
//       socket.off("chat_transferred");
//       socket.off("send_status");
//       socket.off("receive_message");
//       socket.off("chat_ended");
//     };
//   }, [
//     id_employee,
//     senderName,
//     setNotification,
//   ]);

//   const {
//     isOnline,
//     statusBusy,
//     goOnline,
//     goOffline,
//   } = useChatStatus();

//   const transferChat = (emp) => {
//     socket.emit("transfer_chat", {
//       chatId,
//       newEmployeeId: Number(emp.id),
//       oldEmployeeId: id_employee,
//       agentId: agentId,
//       state: stateId,
//       agentName: receiverName,
//     });

//     setOpenTransferModal(false);
//     setShowChat(false);
//     setMessages([]);
//   };

//   const sendMessage = () => {
//     const currentChatId =
//       chatId ||
//       localStorage.getItem("chatId");

//     const currentAgentId =
//       agentId ||
//       localStorage.getItem("agentId");

//     const currentReceiverName =
//       receiverName ||
//       localStorage.getItem("receiverName");

//     if (
//       input.trim() &&
//       currentChatId &&
//       currentAgentId
//     ) {
//       const messageData = {
//         chatId: currentChatId,
//         senderId: id_employee,
//         receiverId: Number(currentAgentId),
//         message: input,
//         senderName: senderName,
//         receiverName: currentReceiverName,
//         timestamp: new Date().toISOString(),
//         type: "text",
//       };

//       socket.emit(
//         "new_message",
//         messageData
//       );

//       setMessages((prev) => [
//         ...prev,
//         {
//           sender: "Me",
//           text: input,
//           type: "text",
//           time: messageData.timestamp,
//         },
//       ]);

//       setInput("");
//     } else {
//       console.warn(
//         "Cannot send message. Missing chatId, agentId, or empty input."
//       );
//     }
//   };

//   const endChat = () => {
//     socket.emit("end_chat", {
//       chatId,
//       employeeId: id_employee,
//       agentId: agentId,
//     });

//     setShowChat(false);
//     setMessages([]);

//     localStorage.removeItem("chatId");
//     localStorage.removeItem("agentId");
//     localStorage.removeItem("stateId");
//     localStorage.removeItem("receiverName");
//   };

//   const handleTyping = () => {
//     socket.emit("typing", {
//       chatId,
//       senderId: id_employee,
//       receiverId: agentId,
//       senderName: senderName,
//     });

//     clearTimeout(timeoutId);

//     const newTimeout = setTimeout(() => {
//       socket.emit("stop_typing", {
//         chatId,
//         senderId: id_employee,
//         receiverId: agentId,
//         senderName: senderName,
//       });
//     }, 2000);

//     setTimeoutId(newTimeout);
//   };

//   const lastMessageRef = useRef(null);

//   useEffect(() => {
//     lastMessageRef.current?.scrollIntoView({
//       behavior: "smooth",
//       block: "end",
//     });
//   }, [messages]);

//   const sendStatusDirect = (
//     type,
//     {
//       agentId,
//       state,
//       website,
//       subuserId,
//     }
//   ) => {
//     socket.emit("get_status", {
//       agentId: Number(agentId),
//       employeeId: id_employee,
//       employeeName: senderName,
//       type,
//       reason: rejectReason,
//       website,
//       state,
//       subuserId,
//     });

//     setOpenModel(false);

//     if (type === "accept") {
//       setShowChat(true);
//     }
//   };

//   const handleUrgentAlert = () => {
//     if (!chatId || !agentId) return;

//     socket.emit(
//       "request_urgent_response",
//       {
//         chatId,
//         agentId,
//         id_employee,
//       }
//     );

//     setUrgentActive(true);
//     urgentActiveRef.current = true;
//     setUrgentTimeLeft(30);

//     if (urgentIntervalRef.current) {
//       clearInterval(
//         urgentIntervalRef.current
//       );
//     }

//     urgentIntervalRef.current =
//       setInterval(() => {
//         setUrgentTimeLeft((prev) => {
//           if (prev <= 1) {
//             clearInterval(
//               urgentIntervalRef.current
//             );

//             urgentIntervalRef.current = null;

//             setUrgentActive(false);
//             urgentActiveRef.current = false;

//             endChat();

//             return 0;
//           }

//           return prev - 1;
//         });
//       }, 1000);
//   };

//   // Runs the real action only after the user confirms in the popup
//   const handleConfirm = () => {
//     if (confirmAction === "alert") handleUrgentAlert();
//     if (confirmAction === "end") endChat();
//     setConfirmAction(null);
//   };

//   useEffect(() => {
//     console.log(
//       "urgentActive updated:",
//       urgentActive
//     );
//   }, [urgentActive]);

//   useEffect(() => {
//     console.log(
//       "[OPEN CHAT MODAL]",
//       {
//         openModel,
//         agentId,
//         chatId,
//         stateId,
//       }
//     );
//   }, [openModel]);

//   return (
//     <>
//       <PageTitle sidebar={sidebar} />

//       {showChat === true ? (
//         <div className="w-full px-2 sm:px-4 pb-4">
//           <div className="flex flex-col lg:flex-row w-full gap-4">
//             <div
//               className="flex flex-col text-gray-900 w-full lg:w-3/4 bg-white rounded-lg shadow-lg overflow-hidden min-w-0"
//               style={{
//                 height:
//                   "calc(100dvh - 180px)",
//                 minHeight: "500px",
//               }}
//             >
//               {/* <div className="flex items-center justify-between px-3 sm:px-4 py-3 text-sm border-b border-gray-100 shrink-0">
//                 <div className="">
//                   Chat with Agent{" "}
//                   <span className="font-bold break-words">
//                     {agentName} [{agentRefId}]
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-3">
//                   <button
//                     onClick={() =>
//                       setConfirmAction("alert")
//                     }
//                     className="py-1 px-3 text-red-700 border border-red-700 rounded-lg font-semibold whitespace-nowrap"
//                   >
//                     Alert
//                   </button>
//                   <button
//                     onClick={() =>
//                       setConfirmAction("end")
//                     }
//                     className="py-1 px-3 text-red-700 border border-red-700 rounded-lg font-semibold whitespace-nowrap"
//                   >
//                     End Chat
//                   </button>
//                 </div>
//               </div> */}

//               <div className="flex items-center justify-between gap-2 px-2 sm:px-4 py-3 text-sm border-b border-gray-100 shrink-0">
//                 <div className="min-w-0 flex-1 pr-1">
//                   <div className="text-gray-700 leading-5 break-words">
//                     Chat with Agent{" "}
//                     <span className="font-bold break-words">
//                       {agentName} [{agentRefId}]
//                     </span>
//                   </div>
//                 </div>

//                 <div className="flex items-center gap-2 sm:gap-3 shrink-0">
//                   <button
//                     onClick={() => setConfirmAction("alert")}
//                     title="Alert"
//                     className="h-8 w-8 sm:h-auto sm:w-auto sm:py-1 sm:px-3 text-red-700 border border-red-700 rounded-lg font-semibold flex items-center justify-center gap-1.5 hover:bg-red-50 transition-colors"
//                   >
//                     <TbBellRingingFilled className="inline sm:hidden text-lg sm:text-base" />

//                     <span className="hidden sm:inline">
//                       Alert
//                     </span>
//                   </button>

//                   <button
//                     onClick={() => setConfirmAction("end")}
//                     title="End Chat"
//                     className="h-8 w-8 sm:h-auto sm:w-auto sm:py-1 sm:px-3 text-red-700 border border-red-700 rounded-lg font-semibold flex items-center justify-center gap-1.5 hover:bg-red-50 transition-colors"
//                   >
//                     <RxCross2 className="inline sm:hidden text-lg sm:text-base" />

//                     <span className="hidden sm:inline">
//                       End Chat
//                     </span>
//                   </button>
//                 </div>
//               </div>



//               <div className="relative flex-1 min-h-0 mx-2 sm:mx-4 my-2 flex flex-col justify-end">
//                 <div style={{ scrollbarWidth: 'thin' }} className="h-full border border-gray-300 p-2 sm:p-3 overflow-y-auto rounded-lg bg-gray-100">
//                   {messages.map(
//                     (msg, index) => {
//                       const adminInfo =
//                         JSON.parse(
//                           localStorage.getItem(
//                             "adminInfo"
//                           )
//                         );

//                       const isMe =
//                         msg.senderId ===
//                         adminInfo?.id ||
//                         msg.sender === "Me" ||
//                         msg.sender ===
//                         adminInfo?.name;

//                       return (
//                         <div
//                           key={index}
//                           className={`p-2 my-1 flex flex-col ${isMe ? "items-end" : "items-start"
//                             }`}
//                         >
//                           <div
//                             className={`flex items-center gap-3 ${isMe ? "flex-row" : "flex-row"
//                               }`}
//                           >

//                             {!isMe && (
//                               <div className="">
//                                 {msg.sender ? (
//                                   <div className="w-5 h-5 p-3 border border-gray-600 rounded-full bg-gray-200 flex items-center justify-center">
//                                     <span className="text-md font-bold text-gray-600">
//                                       {msg.sender.trim().charAt(0).toUpperCase()}
//                                     </span>
//                                   </div>
//                                 ) : (
//                                   <BiSolidUserCircle
//                                     size={25}
//                                     className="text-gray-500"
//                                   />
//                                 )}
//                               </div>
//                             )}

//                             <div>
//                               <div
//                                 className={`text-xs mb-1 ${isMe
//                                   ? "text-green-500"
//                                   : "text-gray-400"
//                                   }`}
//                               >
//                                 {isMe
//                                   ? "Me"
//                                   : msg.sender}
//                               </div>

//                               <div
//                                 className={`rounded-lg p-2 break-words whitespace-pre-wrap [overflow-wrap:anywhere] max-w-[80%] sm:max-w-[75%] ${isMe
//                                   ? "bg-green-500 text-white"
//                                   : "bg-gray-300 text-black"
//                                   }`}
//                               >
//                                 {msg.type === "text" && (
//                                   <span className="block whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
//                                     {msg.text}
//                                   </span>
//                                 )}

//                                 {msg.type === "image" && (
//                                   <img
//                                     src={msg.text}
//                                     alt="Sent"
//                                     className="mt-2 rounded-lg max-w-full sm:max-w-xs h-auto"
//                                   />
//                                 )}

//                                 {msg.type === "pdf" && (
//                                   <a
//                                     href={msg.text}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="block"
//                                   >
//                                     <img
//                                       width="100"
//                                       height="100"
//                                       className="max-w-[100px] h-auto"
//                                       src="https://www.freeiconspng.com/thumbs/pdf-icon-png/pdf-icon-png-pdf-zum-download-2.png"
//                                       alt="PDF Preview"
//                                     />
//                                   </a>
//                                 )}
//                               </div>

//                               <div className="text-xs text-gray-400 mt-1">
//                                 {msg.time &&
//                                   !isNaN(
//                                     new Date(msg.time)
//                                   )
//                                   ? new Date(
//                                     msg.time
//                                   ).toLocaleTimeString(
//                                     "en-GB",
//                                     {
//                                       hour: "2-digit",
//                                       minute: "2-digit",
//                                     }
//                                   )
//                                   : "Invalid Date"}
//                               </div>
//                             </div>

//                             {isMe && (
//                               <div className="flex-shrink-0">
//                                 {msg.sender ? (
//                                   <div className="w-5 h-5 p-3 border border-green-600 rounded-full bg-green-100 flex items-center justify-center">
//                                     <span className="text-md font-bold text-green-600">
//                                       {msg.sender.trim().charAt(0).toUpperCase()}
//                                     </span>
//                                   </div>
//                                 ) : (
//                                   <BiSolidUserCircle
//                                     size={25}
//                                     className="text-green-500"
//                                   />
//                                 )}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     }
//                   )}

//                   {typingUser && (
//                     <div className="flex items-center gap-1 text-sm text-gray-500 px-2 py-2">
//                       <span>
//                         {typingUser} is
//                         typing
//                       </span>

//                       <span className="inline-flex items-center gap-1">
//                         <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" />
//                         <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:150ms]" />
//                         <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:300ms]" />
//                       </span>
//                     </div>

//                   )}
//                   <div
//                     ref={lastMessageRef}
//                     className="h-2"
//                   />
//                 </div>

//                 {urgentActive && (
//                   <div className="w-full flex justify-center my-2 shrink-0">
//                     <div className="inline-flex items-center justify-center gap-3 bg-red-500 text-white px-4 py-2 rounded-full shadow-md border border-red-600">
//                       <span className="font-semibold text-xs sm:text-sm whitespace-nowrap">
//                         Wait for agent response
//                       </span>

//                       <div className="flex items-center justify-center px-2 py-0.5 bg-white text-red-500 rounded-full font-bold text-xs sm:text-sm">
//                         {urgentTimeLeft}s
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div className="flex items-center gap-2 mx-2 sm:mx-4 mb-2 border border-gray-300 px-2 py-1 rounded-lg shrink-0 min-w-0">
//                 <div className="shrink-0">
//                   <Uploader
//                     imageUrl={imageUrl}
//                     setImageUrl={setImageUrl}
//                     name_merge="Employee"
//                     folder="chat"
//                     chatId={chatId}
//                     senderId={id_employee}
//                     receiverId={agentId}
//                     senderName={senderName}
//                     setMessages={
//                       setMessages
//                     }
//                     receiverName={
//                       receiverName
//                     }
//                   />
//                 </div>

//                 <input
//                   type="text"
//                   value={input}
//                   maxLength={1000}
//                   onChange={(e) => {
//                     setInput(e.target.value);
//                     handleTyping();
//                   }}
//                   onKeyDown={(e) =>
//                     e.key === "Enter" &&
//                     sendMessage()
//                   }
//                   placeholder="Type a message..."
//                   className="flex-1 min-w-0 p-1 rounded-lg bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//                 <button
//                   onClick={sendMessage}
//                   className="shrink-0 flex items-center justify-center  rounded-full transition-all duration-300 ease-in-out transform hover:scale-105"
//                 >
//                   <IoSendSharp className="text-green-500 hover:text-green-600 m-0 p-0" size={24} />
//                 </button>
//               </div>
//             </div>

//             {isOnline && (
//               <div
//                 className="w-full lg:w-1/4 bg-white rounded-lg shadow-lg p-3 sm:p-4 overflow-y-auto min-w-0"
//                 style={{
//                   height:
//                     "auto",
//                   maxHeight:
//                     "calc(100dvh - 180px)",
//                   minHeight: "250px",
//                 }}
//               >
//                 <div className="mb-4">
//                   <SelectSingleState
//                     stateId={stateId}
//                     onChange={(e) => {
//                       const selectedState =
//                         e.target.value;

//                       setStateId(
//                         selectedState
//                       );

//                       localStorage.setItem(
//                         "stateId",
//                         selectedState
//                       );
//                     }}
//                   />
//                 </div>

//                 <h3 className="text-sm font-bold mb-2">
//                   Employees:
//                 </h3>

//                 <div className="space-y-1">
//                   {users.map((user) => (
//                     <button
//                       key={user.id}
//                       style={{
//                         backgroundColor:
//                           user.is_online
//                             ? "#7BE569"
//                             : "#6B7280",
//                       }}
//                       className="p-2 text-white rounded-lg w-full text-left hover:opacity-90 transition-opacity flex items-center justify-between gap-2"
//                       onClick={() => {
//                         if (
//                           user.is_online &&
//                           user.chat_status ===
//                           "Unassigned"
//                         ) {
//                           setOpenTransferModal(
//                             true
//                           );
//                           setSelectedEmp(
//                             user
//                           );
//                         }
//                       }}
//                     >
//                       <span className="truncate min-w-0">
//                         {user.name}
//                       </span>

//                       <span
//                         className={`shrink-0 text-xs px-2 py-1 rounded-lg ${user.chat_status ===
//                           "Unassigned"
//                           ? "bg-white text-black"
//                           : "bg-red-600 text-white"
//                           }`}
//                       >
//                         {user.chat_status ===
//                           "Unassigned"
//                           ? "Available"
//                           : "Busy"}
//                       </span>
//                     </button>
//                   ))}
//                   {users?.length == 0 && <span className="w-full text-gray-500 text-xs sm:text-sm">No Employee available</span>}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       ) : (
//         <>
//           {profile === "User" ? (
//             isOnline &&
//             showChat && (
//               <div
//                 className="w-full sm:w-1/2 lg:w-1/4 ml-auto mt-4 bg-white rounded-lg shadow-lg p-4 overflow-y-auto"
//                 style={{
//                   height: "auto",
//                   maxHeight:
//                     "calc(100dvh - 180px)",
//                   minHeight: "250px",
//                 }}
//               >
//                 <h3 className="text-sm font-bold mb-2">
//                   Employees:
//                 </h3>

//                 <div className="space-y-1">
//                   {users.map((user) => (
//                     <button
//                       key={user.id}
//                       style={{
//                         backgroundColor:
//                           user.is_online
//                             ? "#7BE569"
//                             : "#6B7280",
//                       }}
//                       className="p-2 text-white rounded-lg w-full hover:opacity-90 flex items-center justify-between gap-2"
//                       onClick={() => {
//                         if (
//                           user.is_online &&
//                           user.chat_status ===
//                           "Unassigned"
//                         ) {
//                           setOpenTransferModal(
//                             true
//                           );
//                           setSelectedEmp(
//                             user
//                           );
//                         }
//                       }}
//                     >
//                       <span className="truncate">
//                         {user.name}
//                       </span>

//                       <span className="text-xs shrink-0 bg-white text-black px-2 py-1 rounded-lg">
//                         {user.chat_status}
//                       </span>
//                     </button>
//                   ))}
//                   {users?.length == 0 && <span className="w-full text-gray-500 text-xs sm:text-sm">No Employee available</span>}
//                 </div>
//               </div>
//             )
//           ) : (
//             <>
//               <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
//                 <CardItemTwo
//                   mode={mode}
//                   currency={currency}
//                   title="Today Order"
//                   title2="TodayOrder"
//                   Icon={ImStack}
//                   cash={
//                     todayCashPayment || 0
//                   }
//                   card={
//                     todayCardPayment || 0
//                   }
//                   credit={
//                     todayCreditPayment || 0
//                   }
//                   price={
//                     todayOrderAmount || 0
//                   }
//                   className="text-white dark:text-green-100 bg-teal-500"
//                   loading={
//                     loadingOrderAmount
//                   }
//                 />

//                 <CardItemTwo
//                   mode={mode}
//                   currency={currency}
//                   title="Yesterday Order"
//                   title2="YesterdayOrder"
//                   Icon={ImStack}
//                   cash={
//                     yesterdayCashPayment ||
//                     0
//                   }
//                   card={
//                     yesterdayCardPayment ||
//                     0
//                   }
//                   credit={
//                     yesterdayCreditPayment ||
//                     0
//                   }
//                   price={
//                     yesterdayOrderAmount ||
//                     0
//                   }
//                   className="text-white dark:text-orange-100 bg-orange-400"
//                   loading={
//                     loadingOrderAmount
//                   }
//                 />

//                 <CardItemTwo
//                   mode={mode}
//                   currency={currency}
//                   title2="ThisMonth"
//                   Icon={FiShoppingCart}
//                   price={
//                     dashboardOrderAmount?.thisMonthlyOrderAmount ||
//                     0
//                   }
//                   className="text-white dark:text-green-100 bg-blue-500"
//                   loading={
//                     loadingOrderAmount
//                   }
//                 />

//                 <CardItemTwo
//                   mode={mode}
//                   currency={currency}
//                   title2="AllTimeSales"
//                   Icon={ImCreditCard}
//                   price={
//                     dashboardOrderAmount?.totalAmount ||
//                     0
//                   }
//                   className="text-white dark:text-green-100 bg-green-500"
//                   loading={
//                     loadingOrderAmount
//                   }
//                 />
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
//                 <CardItem
//                   title="Total Order"
//                   Icon={FiShoppingCart}
//                   loading={
//                     loadingOrderCount
//                   }
//                   quantity={
//                     dashboardOrderCount?.totalOrder ||
//                     0
//                   }
//                   className="text-orange-600 dark:text-orange-100 bg-orange-100 dark:bg-orange-500"
//                 />

//                 <CardItem
//                   title={t(
//                     "OrderPending"
//                   )}
//                   Icon={FiRefreshCw}
//                   loading={
//                     loadingOrderCount
//                   }
//                   quantity={
//                     dashboardOrderCount
//                       ?.totalPendingOrder
//                       ?.count || 0
//                   }
//                   amount={
//                     dashboardOrderCount
//                       ?.totalPendingOrder
//                       ?.total || 0
//                   }
//                   className="text-blue-600 dark:text-blue-100 bg-blue-100 dark:bg-blue-500"
//                 />

//                 <CardItem
//                   title={t(
//                     "OrderProcessing"
//                   )}
//                   Icon={FiTruck}
//                   loading={
//                     loadingOrderCount
//                   }
//                   quantity={
//                     dashboardOrderCount?.totalProcessingOrder ||
//                     0
//                   }
//                   className="text-teal-600 dark:text-teal-100 bg-teal-100 dark:bg-teal-500"
//                 />

//                 <CardItem
//                   title={t(
//                     "OrderDelivered"
//                   )}
//                   Icon={FiCheck}
//                   loading={
//                     loadingOrderCount
//                   }
//                   quantity={
//                     dashboardOrderCount?.totalDeliveredOrder ||
//                     0
//                   }
//                   className="text-green-600 dark:text-green-100 bg-green-100 dark:bg-green-500"
//                 />
//               </div>
//             </>
//           )}
//         </>
//       )}

//       {showChat && (
//         <Modal
//           className="relative bg-white p-4 sm:p-5 w-[calc(100%-2rem)] sm:w-full sm:max-w-md overflow-hidden rounded-md"
//           isOpen={openTransferModal}
//           onClose={() =>
//             setOpenTransferModal(false)
//           }
//         >
//           <div className="mb-4 pb-2 text-sm sm:text-base break-words">
//             Transfer chat to{" "}
//             <span className="font-semibold">
//               {selectedEmp?.name}
//             </span>{" "}
//             ?
//           </div>

//           <div className="flex flex-col sm:flex-row gap-2">
//             <Button
//               layout="outline"
//               className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
//               onClick={() =>
//                 transferChat(
//                   selectedEmp
//                 )
//               }
//             >
//               Yes
//             </Button>

//             <Button
//               layout="outline"
//               className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
//               onClick={() =>
//                 setOpenTransferModal(false)
//               }
//             >
//               No
//             </Button>
//           </div>
//         </Modal>
//       )}

//       {showChat && (
//         <Modal
//           className="relative bg-white p-4 sm:p-5 w-[calc(100%-2rem)] sm:w-full sm:max-w-md overflow-hidden rounded-md"
//           isOpen={confirmAction !== null}
//           onClose={() => setConfirmAction(null)}
//         >
//           <div className="mb-4 pb-2 text-sm sm:text-base break-words">
//             {confirmAction === "alert"
//               ? "Send an urgent alert to the agent?"
//               : "Are you sure you want to end this chat?"}
//           </div>

//           <div className="flex flex-col sm:flex-row gap-2">
//             <Button
//               layout="outline"
//               className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
//               onClick={handleConfirm}
//             >
//               Yes
//             </Button>

//             <Button
//               layout="outline"
//               className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
//               onClick={() => setConfirmAction(null)}
//             >
//               No
//             </Button>
//           </div>
//         </Modal>
//       )}
//     </>
//   );
// };

// export default Dashboard;




import { WindmillContext } from "@windmill/react-ui";
import CardItem from "components/dashboard/CardItem";
import CardItemTwo from "components/dashboard/CardItemTwo";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import * as dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FiCheck, FiRefreshCw, FiShoppingCart, FiTruck } from "react-icons/fi";
import { ImCreditCard, ImStack } from "react-icons/im";
import OrderServices from "services/OrderServices";
import socket from "services/SocketService";
import ChatServices from "services/ChatServices";
import { notifySuccess, notifyError } from "utils/toast";
import { IoSendSharp } from "react-icons/io5";
import Uploader from "components/image-uploader/UploaderChat";
import { Modal, Button } from "@windmill/react-ui";
import SelectState from "components/form/SelectStaffState";
import SelectSingleState from "components/form/SelectSingleState";
import { requestNotificationPermission, showBrowserNotification, setupPushNotifications } from "utils/browserNotify";
import useSidebar from "routes/sidebar";
import { useChatStatus } from "context/ChatStatusContext";
import { BiSolidUserCircle } from "react-icons/bi";
import { RxCross2 } from "react-icons/rx";
import { TbBellRingingFilled } from "react-icons/tb";

const Dashboard = () => {
  const { globalSetting } = useFilter();
  const { mode } = useContext(WindmillContext);

  useEffect(() => {
    requestNotificationPermission().then((granted) => {
      if (granted) setupPushNotifications(ChatServices.savePushSubscription);
    });
  }, []);

  const [showChat, setShowChat] = useState(false);
  const [users, setUsers] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [typingUser, setTypingUser] = useState(null);
  const [timeoutId, setTimeoutId] = useState();
  const [imageUrl, setImageUrl] = useState();
  const [chatId, setChatId] = useState();
  const [agentId, setAgentId] = useState();
  const [agentRefId, setAgentRefId] = useState()

  const [stateId, setStateId] = useState(() => {
    return localStorage.getItem("stateId") || null;
  });

  const [showReason, setShowReason] = useState(false);
  const [receiverName, setReceiverName] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [history, setHistory] = useState();
  const [website, setWebsite] = useState();
  const [subuserId, setSubuserId] = useState();
  const [selectedEmp, setSelectedEmp] = useState();
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [selectedState, setSelectedState] = useState(null);

  const [urgentActive, setUrgentActive] = useState(false);
  const urgentActiveRef = useRef(false);
  const [urgentTimeLeft, setUrgentTimeLeft] = useState(0);
  const urgentIntervalRef = useRef(null);
  const [chatEnded, setChatEnded] = useState(false);

  const [confirmAction, setConfirmAction] = useState(null);

  const { sidebar } = useSidebar();

  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const senderName = adminInfo?.name;
  const profile = adminInfo?.profile;

  dayjs.extend(isBetween);
  dayjs.extend(isToday);
  dayjs.extend(isYesterday);

  const { setNotification } = useContext(SidebarContext);

  const [todayOrderAmount, setTodayOrderAmount] = useState(0);
  const [yesterdayOrderAmount, setYesterdayOrderAmount] = useState(0);
  const [salesReport, setSalesReport] = useState([]);
  const [todayCashPayment, setTodayCashPayment] = useState(0);
  const [todayCardPayment, setTodayCardPayment] = useState(0);
  const [todayCreditPayment, setTodayCreditPayment] = useState(0);
  const [yesterdayCashPayment, setYesterdayCashPayment] = useState(0);
  const [yesterdayCardPayment, setYesterdayCardPayment] = useState(0);
  const [yesterdayCreditPayment, setYesterdayCreditPayment] = useState(0);

  const { data: dashboardOrderCount, loading: loadingOrderCount } = useAsync(
    OrderServices.getDashboardCount
  );

  const { data: dashboardOrderAmount, loading: loadingOrderAmount } = useAsync(
    OrderServices.getDashboardAmount
  );

  const currency = globalSetting?.default_currency || "$";

  const { t } = useTranslation();

  useEffect(() => {
    socket.on("typing", ({ chatId, senderId, receiverId, senderName }) => {
      setTypingUser(senderName);
    });

    socket.on("stop_typing", ({ chatId, senderId, receiverId, senderName }) => {
      setTypingUser(null);
    });

    return () => {
      socket.off("typing");
      socket.off("stop_typing");
    };
  }, []);

  useEffect(() => {
    if (!stateId) {
      console.log("No state selected, exiting useEffect.");
      return;
    }

    const handleAvailableEmployees = ({ employees }) => {
      const filteredEmployees = employees
        .filter((emp) => Number(emp.id) !== Number(id_employee))
        .sort((a, b) => b.is_online - a.is_online);

      setUsers(filteredEmployees);
    };

    socket.on("available_employees", handleAvailableEmployees);

    socket.emit("get_available_emp", {
      state: stateId,
      employeeId: id_employee,
    });

    return () => {
      socket.off("available_employees", handleAvailableEmployees);
    };
  }, [stateId]);

  useEffect(() => {
    const todayOrder = dashboardOrderAmount?.ordersData?.filter((order) =>
      dayjs(order.updatedAt).isToday()
    );

    const todayReport = todayOrder?.reduce(
      (pre, acc) => pre + acc.total,
      0
    );

    setTodayOrderAmount(todayReport);

    const yesterdayOrder = dashboardOrderAmount?.ordersData?.filter((order) =>
      dayjs(order.updatedAt).set(-1, "day").isYesterday()
    );

    const yesterdayReport = yesterdayOrder?.reduce(
      (pre, acc) => pre + acc.total,
      0
    );

    setYesterdayOrderAmount(yesterdayReport);

    const salesOrderChartData = dashboardOrderAmount?.ordersData?.filter(
      (order) =>
        dayjs(order.updatedAt).isBetween(
          new Date().setDate(new Date().getDate() - 7),
          new Date()
        )
    );

    salesOrderChartData?.reduce((res, value) => {
      let onlyDate = value.updatedAt.split("T")[0];

      if (!res[onlyDate]) {
        res[onlyDate] = {
          date: onlyDate,
          total: 0,
          order: 0,
        };

        salesReport.push(res[onlyDate]);
      }

      res[onlyDate].total += value.total;
      res[onlyDate].order += 1;

      return res;
    }, {});

    setSalesReport(salesReport);

    const todayPaymentMethodData = [];
    const yesterDayPaymentMethodData = [];

    dashboardOrderAmount?.ordersData?.filter((item, value) => {
      if (dayjs(item.updatedAt).isToday()) {
        if (item.paymentMethod === "Cash") {
          let cashMethod = {
            paymentMethod: "Cash",
            total: item.total,
          };

          todayPaymentMethodData.push(cashMethod);
        }

        if (item.paymentMethod === "Credit") {
          const cashMethod = {
            paymentMethod: "Credit",
            total: item.total,
          };

          todayPaymentMethodData.push(cashMethod);
        }

        if (item.paymentMethod === "Card") {
          const cashMethod = {
            paymentMethod: "Card",
            total: item.total,
          };

          todayPaymentMethodData.push(cashMethod);
        }
      }

      return item;
    });

    dashboardOrderAmount?.ordersData?.filter((item, value) => {
      if (dayjs(item.updatedAt).set(-1, "day").isYesterday()) {
        if (item.paymentMethod === "Cash") {
          let cashMethod = {
            paymentMethod: "Cash",
            total: item.total,
          };

          yesterDayPaymentMethodData.push(cashMethod);
        }

        if (item.paymentMethod === "Credit") {
          const cashMethod = {
            paymentMethod: "Credit",
            total: item?.total,
          };

          yesterDayPaymentMethodData.push(cashMethod);
        }

        if (item.paymentMethod === "Card") {
          const cashMethod = {
            paymentMethod: "Card",
            total: item?.total,
          };

          yesterDayPaymentMethodData.push(cashMethod);
        }
      }

      return item;
    });

    const todayCsCdCit = Object.values(
      todayPaymentMethodData.reduce((r, { paymentMethod, total }) => {
        if (!r[paymentMethod]) {
          r[paymentMethod] = {
            paymentMethod,
            total: 0,
          };
        }

        r[paymentMethod].total += total;

        return r;
      }, {})
    );

    const today_cash_payment = todayCsCdCit.find(
      (el) => el.paymentMethod === "Cash"
    );

    setTodayCashPayment(today_cash_payment?.total);

    const today_card_payment = todayCsCdCit.find(
      (el) => el.paymentMethod === "Card"
    );

    setTodayCardPayment(today_card_payment?.total);

    const today_credit_payment = todayCsCdCit.find(
      (el) => el.paymentMethod === "Credit"
    );

    setTodayCreditPayment(today_credit_payment?.total);

    const yesterDayCsCdCit = Object.values(
      yesterDayPaymentMethodData.reduce((r, { paymentMethod, total }) => {
        if (!r[paymentMethod]) {
          r[paymentMethod] = {
            paymentMethod,
            total: 0,
          };
        }

        r[paymentMethod].total += total;

        return r;
      }, {})
    );

    const yesterday_cash_payment = yesterDayCsCdCit.find(
      (el) => el.paymentMethod === "Cash"
    );

    setYesterdayCashPayment(yesterday_cash_payment?.total);

    const yesterday_card_payment = yesterDayCsCdCit.find(
      (el) => el.paymentMethod === "Card"
    );

    setYesterdayCardPayment(yesterday_card_payment?.total);

    const yesterday_credit_payment = yesterDayCsCdCit.find(
      (el) => el.paymentMethod === "Credit"
    );

    setYesterdayCreditPayment(yesterday_credit_payment?.total);
  }, [dashboardOrderAmount]);

  useEffect(() => {
    if (!socket.connected) socket.connect();

    const storedChatId = localStorage.getItem("chatId");
    const storedAgentId = localStorage.getItem("agentId");
    const storedReceiverName = localStorage.getItem("receiverName");
    const storedStateId = localStorage.getItem("stateId");

    const saveChatData = ({
      chatId,
      agentId,
      state,
      agentName,
      agentRef
    }) => {
      setChatId(chatId);
      setAgentId(agentId);
      setAgentRefId(agentRef)
      setStateId(state);
      setReceiverName(agentName);

      localStorage.setItem("chatId", chatId);
      localStorage.setItem("agentId", agentId);
      localStorage.setItem("stateId", state);
      localStorage.setItem("receiverName", agentName);
      localStorage.setItem("agentRefId", agentRefId)
    };

    const fetchAvailableEmployees = (stateIdToUse) => {
      if (!stateIdToUse) return;

      socket.emit("get_available_emp", {
        state: stateIdToUse,
        employeeId: id_employee,
      });
    };

    const handleConnect = () => {
      socket.emit("register", [
        id_employee,
        senderName,
        "employee",
        sessionStorage.getItem("isOnline") === "true",
      ]);

      socket.on(
        "resume_chat",
        ({ chatId, agentId, stateId, agentRef }) => {
          setChatId(chatId);
          setAgentId(agentId);
          setAgentRefId(agentRef)
          setShowChat(true);

          fetchAvailableEmployees(stateId);

          socket.emit("chat_list", {
            chatId,
            agentId,
          });

          localStorage.setItem("chatId", chatId);
          localStorage.setItem("agentId", agentId);
          localStorage.setItem("agentRefId", agentRefId);
        }
      );

      if (
        storedChatId &&
        storedAgentId &&
        storedReceiverName
      ) {
        setChatId(storedChatId);
        setAgentId(storedAgentId);
        setAgentRefId(storedAgentId)
        setReceiverName(storedReceiverName);
        setShowChat(true);

        socket.emit("chat_list", {
          chatId: storedChatId,
          agentId: storedAgentId,
        });
      }
    };

    const handleChatHistory = ({ rows }) => {
      if (rows) {
        const formattedMessages = rows.map((msg) => ({
          sender: msg.sender_name,
          senderId: msg.sender_id,
          receiverId: msg.receiver_id,
          chatId: msg.chat_id,
          text: msg.message,
          type: msg.type,
          time: msg.timestamp,
        }));

        setMessages(formattedMessages);
      }
    };

    const handleNotification = (data) => {
      setNotification((prev) => [...prev, data]);
      showBrowserNotification(
        data?.title || "B2B Cabs",
        data?.message || "You have a new notification"
      );
    };

    socket.on("connect", handleConnect);

    if (socket.connected) {
      handleConnect();
    }

    socket.on("get_chat", handleChatHistory);

    socket.on("receiveNotification", handleNotification);

    socket.on("new_customer", ({ chatId, agentId, state, agentName, agentRef }) => {
      console.log("New customer connected:", chatId, agentId, agentName, agentRef);
      saveChatData({ chatId, agentId, state, agentName, agentRef });
      fetchAvailableEmployees(storedStateId);
      if (agentId) {
        socket.emit("chat_list", { chatId, agentId });
      }
      showBrowserNotification(
        "New chat assigned",
        agentName ? `${agentName} is waiting for you` : "A customer is waiting for you"
      );
    });

    socket.on(
      "chat_transferred",
      ({
        chatId,
        newEmployeeId,
        oldEmployeeId,
        agentId,
        state,
        agentName,
        chatHistory,
        agentRef
      }) => {
        const transformedMessages = chatHistory.map(
          (msg) => ({
            sender: msg.sender_name,
            text: msg.message,
            time: msg.timestamp,
            type: msg.type,
          })
        );

        setMessages((prev) => [...prev, ...transformedMessages]);
        setShowChat(true);
        saveChatData({ chatId, agentId, state, agentName, agentRef });
      });

    socket.on(
      "send_status",
      ({
        agentId,
        subuserId,
        state,
        website,
        agentRef
      }) => {
        if (agentId && state && website) {
          if (
            sessionStorage.getItem("isOnline") ===
            "true"
          ) {
            sendStatusDirect("accept", {
              agentId,
              subuserId,
              state,
              website,
            });
          } else {
            setAgentId(agentId);
            setAgentRefId(agentRef)
            setStateId(state);
            setWebsite(website);
            setSubuserId(subuserId);
            setOpenModel(true);
          }
        } else {
          console.error(
            "Cannot sendStatus, missing data",
            {
              agentId,
              subuserId,
              state,
              website,
            }
          );
        }
      }
    );

    socket.on(
      "receive_message",
      ({
        chatId: msgChatId,
        senderId,
        message,
        type,
        senderName,
        timestamp,
      }) => {
        setMessages((prev) => [
          ...prev,
          {
            sender: senderName,
            text: message,
            time: timestamp,
            type,
          },
        ]);

        showBrowserNotification(
          senderName || "New message",
          type === "text" ? message : `Sent ${type || "a file"}`
        );

        const currentChatId =
          chatId ||
          localStorage.getItem("chatId");

        const currentAgentId =
          agentId ||
          localStorage.getItem("agentId");

        if (
          urgentActiveRef.current &&
          currentChatId == msgChatId &&
          senderId == currentAgentId
        ) {
          clearInterval(
            urgentIntervalRef.current
          );

          urgentIntervalRef.current = null;

          setUrgentActive(false);
          urgentActiveRef.current = false;
          setUrgentTimeLeft(0);
        }
      }
    );

    socket.on(
      "chat_ended",
      ({
        chatId: endedChatId,
        endedBy,
        message,
      }) => {
        setShowChat(false);
        setMessages([]);
        // Clear the live state too, not just localStorage — otherwise this
        // chat's chatId/agentId linger in React state, and anything that
        // later re-opens the panel (without first fetching a fresh chat)
        // redisplays this now-transferred-away chat instead of nothing.
        setChatId(null);
        setAgentId(null);
        setAgentRefId(null);
        setStateId(null);
        setReceiverName("");

        localStorage.removeItem("chatId");
        localStorage.removeItem("agentId");
        localStorage.removeItem("stateId");
        localStorage.removeItem(
          "receiverName"
        );
      }
    );

    socket.emit("chat_list", {
      chatId,
      agentId,
    });

    return () => {
      socket.off("connect", handleConnect);
      socket.off(
        "get_chat",
        handleChatHistory
      );

      socket.off(
        "receiveNotification",
        handleNotification
      );

      socket.off("new_customer");
      socket.off("chat_transferred");
      socket.off("send_status");
      socket.off("receive_message");
      socket.off("chat_ended");
    };
  }, [
    id_employee,
    senderName,
    setNotification,
  ]);

  const {
    isOnline,
    statusBusy,
    goOnline,
    goOffline,
  } = useChatStatus();

  const transferChat = (emp) => {
    socket.emit("transfer_chat", {
      chatId,
      newEmployeeId: Number(emp.id),
      oldEmployeeId: id_employee,
      agentId: agentId,
      state: stateId,
      agentName: receiverName,
    });

    setOpenTransferModal(false);
    setShowChat(false);
    setMessages([]);
  };

  const sendMessage = () => {
    // Only the live React state decides who a message is sent to — never
    // localStorage here. localStorage is shared by every tab of this
    // browser (including a different employee logged in in another tab),
    // so using it as a live fallback let one tab's chat lifecycle
    // (accept/resume/end) silently redirect another tab's messages to the
    // wrong agent. localStorage is still used, once, to restore state
    // after a page reload (see the mount effect above) — just not here.
    if (
      input.trim() &&
      chatId &&
      agentId
    ) {
      const messageData = {
        chatId,
        senderId: id_employee,
        receiverId: Number(agentId),
        message: input,
        senderName: senderName,
        receiverName,
        timestamp: new Date().toISOString(),
        type: "text",
      };

      socket.emit(
        "new_message",
        messageData
      );

      setMessages((prev) => [
        ...prev,
        {
          sender: messageData.senderName,
          text: input,
          type: "text",
          time: messageData.timestamp,
        },
      ]);

      setInput("");
    } else {
      console.warn(
        "Cannot send message. Missing chatId, agentId, or empty input."
      );
    }
  };

  const endChat = () => {
    socket.emit("end_chat", {
      chatId,
      employeeId: id_employee,
      agentId: agentId,
    });

    setShowChat(false);
    setMessages([]);

    localStorage.removeItem("chatId");
    localStorage.removeItem("agentId");
    localStorage.removeItem("stateId");
    localStorage.removeItem("receiverName");
  };

  const handleTyping = () => {
    socket.emit("typing", {
      chatId,
      senderId: id_employee,
      receiverId: agentId,
      senderName: senderName,
    });

    clearTimeout(timeoutId);

    const newTimeout = setTimeout(() => {
      socket.emit("stop_typing", {
        chatId,
        senderId: id_employee,
        receiverId: agentId,
        senderName: senderName,
      });
    }, 2000);

    setTimeoutId(newTimeout);
  };

  const messagesContainerRef = useRef(null);

  useEffect(() => {
    const container = messagesContainerRef.current;

    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [messages]);

  const sendStatusDirect = (
    type,
    {
      agentId,
      state,
      website,
      subuserId,
    }
  ) => {
    socket.emit("get_status", {
      agentId: Number(agentId),
      employeeId: id_employee,
      employeeName: senderName,
      type,
      reason: rejectReason,
      website,
      state,
      subuserId,
    });

    setOpenModel(false);

    if (type === "accept") {
      setShowChat(true);
    }
  };

  const handleUrgentAlert = () => {
    if (!chatId || !agentId) return;

    socket.emit(
      "request_urgent_response",
      {
        chatId,
        agentId,
        id_employee,
      }
    );

    setUrgentActive(true);
    urgentActiveRef.current = true;
    setUrgentTimeLeft(30);

    if (urgentIntervalRef.current) {
      clearInterval(
        urgentIntervalRef.current
      );
    }

    urgentIntervalRef.current =
      setInterval(() => {
        setUrgentTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(
              urgentIntervalRef.current
            );

            urgentIntervalRef.current = null;

            setUrgentActive(false);
            urgentActiveRef.current = false;

            endChat();

            return 0;
          }

          return prev - 1;
        });
      }, 1000);
  };

  const handleConfirm = () => {
    if (confirmAction === "alert") handleUrgentAlert();
    if (confirmAction === "end") endChat();
    setConfirmAction(null);
  };

  useEffect(() => {
    console.log(
      "urgentActive updated:",
      urgentActive
    );
  }, [urgentActive]);

  useEffect(() => {
    console.log(
      "[OPEN CHAT MODAL]",
      {
        openModel,
        agentId,
        chatId,
        stateId,
      }
    );
  }, [openModel]);

  //   return (
  //   <>
  //     <PageTitle sidebar={sidebar} />

  //     {showChat === true ? (
  //       <div className="w-full px-2 sm:px-4 pb-4">
  //         <div className="flex flex-col lg:flex-row w-full gap-4">
  //           <div
  //             className="flex flex-col text-gray-900 w-full lg:w-3/4 bg-white rounded-lg shadow-lg overflow-hidden min-w-0"
  //             style={{
  //               height:
  //                 "calc(100dvh - 180px)",
  //               minHeight: "500px",
  //             }}
  //           >
  //             <div className="flex items-center justify-between gap-2 px-2 sm:px-4 py-3 text-sm border-b border-gray-100 shrink-0">
  //               <div className="min-w-0 flex-1 pr-1">
  //                 <div className="text-gray-700 leading-5 break-words">
  //                   Chat with Agent{" "}
  //                   <span className="font-bold break-words">
  //                     {agentName} [{agentRefId}]
  //                   </span>
  //                 </div>
  //               </div>

  //               <div className="flex items-center gap-2 sm:gap-3 shrink-0">
  //                 <button
  //                   onClick={() => setConfirmAction("alert")}
  //                   title="Alert"
  //                   className="h-8 w-8 sm:h-auto sm:w-auto sm:py-1 sm:px-3 text-red-700 border border-red-700 rounded-lg font-semibold flex items-center justify-center gap-1.5 hover:bg-red-50 transition-colors"
  //                 >
  //                   <TbBellRingingFilled className="inline sm:hidden text-lg sm:text-base" />

  //                   <span className="hidden sm:inline">
  //                     Alert
  //                   </span>
  //                 </button>

  //                 <button
  //                   onClick={() => setConfirmAction("end")}
  //                   title="End Chat"
  //                   className="h-8 w-8 sm:h-auto sm:w-auto sm:py-1 sm:px-3 text-red-700 border border-red-700 rounded-lg font-semibold flex items-center justify-center gap-1.5 hover:bg-red-50 transition-colors"
  //                 >
  //                   <RxCross2 className="inline sm:hidden text-lg sm:text-base" />

  //                   <span className="hidden sm:inline">
  //                     End Chat
  //                   </span>
  //                 </button>
  //               </div>
  //             </div>

  //             <div className="relative flex-1 min-h-0 mx-2 sm:mx-4 my-2 flex flex-col">
  //               <div
  //                 ref={messagesContainerRef}
  //                 style={{
  //                   scrollbarWidth: "thin",
  //                   overflowAnchor: "none",
  //                 }}
  //                 className="flex-1 min-h-0 border border-gray-300 p-2 sm:p-3 overflow-y-auto rounded-lg bg-gray-100"
  //               >
  //                 {messages.map(
  //                   (msg, index) => {
  //                     const adminInfo =
  //                       JSON.parse(
  //                         localStorage.getItem(
  //                           "adminInfo"
  //                         )
  //                       );

  //                     const isMe =
  //                       msg.senderId ===
  //                       adminInfo?.id ||
  //                       msg.sender === "Me" ||
  //                       msg.sender ===
  //                       adminInfo?.name;

  //                     return (
  //                       <div
  //                         key={index}
  //                         className={`p-2 my-1 flex flex-col ${isMe ? "items-end" : "items-start"
  //                           }`}
  //                       >
  //                         <div
  //                           className={`flex items-center gap-3 ${isMe ? "flex-row" : "flex-row"
  //                             }`}
  //                         >
  //                           {!isMe && (
  //                             <div className="">
  //                               {msg.sender ? (
  //                                 <div className="w-5 h-5 p-3 border border-gray-600 rounded-full bg-gray-200 flex items-center justify-center">
  //                                   <span className="text-md font-bold text-gray-600">
  //                                     {msg.sender.trim().charAt(0).toUpperCase()}
  //                                   </span>
  //                                 </div>
  //                               ) : (
  //                                 <BiSolidUserCircle
  //                                   size={25}
  //                                   className="text-gray-500"
  //                                 />
  //                               )}
  //                             </div>
  //                           )}

  //                           <div>
  //                             <div
  //                               className={`text-xs mb-1 ${isMe
  //                                 ? "text-green-500"
  //                                 : "text-gray-400"
  //                                 }`}
  //                             >
  //                               {isMe
  //                                 ? "Me"
  //                                 : msg.sender}
  //                             </div>

  //                             <div
  //                               className={`rounded-lg p-2 break-words whitespace-pre-wrap [overflow-wrap:anywhere] max-w-[80%] sm:max-w-[75%] ${isMe
  //                                 ? "bg-green-500 text-white"
  //                                 : "bg-gray-300 text-black"
  //                                 }`}
  //                             >
  //                               {msg.type === "text" && (
  //                                 <span className="block whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
  //                                   {msg.text}
  //                                 </span>
  //                               )}

  //                               {msg.type === "image" && (
  //                                 <img
  //                                   src={msg.text}
  //                                   alt="Sent"
  //                                   className="mt-2 rounded-lg max-w-full sm:max-w-xs h-auto"
  //                                 />
  //                               )}

  //                               {msg.type === "pdf" && (
  //                                 <a
  //                                   href={msg.text}
  //                                   target="_blank"
  //                                   rel="noopener noreferrer"
  //                                   className="block"
  //                                 >
  //                                   <img
  //                                     width="100"
  //                                     height="100"
  //                                     className="max-w-[100px] h-auto"
  //                                     src="https://www.freeiconspng.com/thumbs/pdf-icon-png/pdf-icon-png-pdf-zum-download-2.png"
  //                                     alt="PDF Preview"
  //                                   />
  //                                 </a>
  //                               )}
  //                             </div>

  //                             <div className="text-xs text-gray-400 mt-1">
  //                               {msg.time &&
  //                                 !isNaN(
  //                                   new Date(msg.time)
  //                                 )
  //                                 ? new Date(
  //                                   msg.time
  //                                 ).toLocaleTimeString(
  //                                   "en-GB",
  //                                   {
  //                                     hour: "2-digit",
  //                                     minute: "2-digit",
  //                                   }
  //                                 )
  //                                 : "Invalid Date"}
  //                             </div>
  //                           </div>

  //                           {isMe && (
  //                             <div className="flex-shrink-0">
  //                               {msg.sender ? (
  //                                 <div className="w-5 h-5 p-3 border border-green-600 rounded-full bg-green-100 flex items-center justify-center">
  //                                   <span className="text-md font-bold text-green-600">
  //                                     {msg.sender.trim().charAt(0).toUpperCase()}
  //                                   </span>
  //                                 </div>
  //                               ) : (
  //                                 <BiSolidUserCircle
  //                                   size={25}
  //                                   className="text-green-500"
  //                                 />
  //                               )}
  //                             </div>
  //                           )}
  //                         </div>
  //                       </div>
  //                     );
  //                   }
  //                 )}

  //                 {typingUser && (
  //                   <div className="flex items-center gap-1 text-sm text-gray-500 px-2 py-2">
  //                     <span>
  //                       {typingUser} is
  //                       typing
  //                     </span>

  //                     <span className="inline-flex items-center gap-1">
  //                       <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" />
  //                       <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:150ms]" />
  //                       <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:300ms]" />
  //                     </span>
  //                   </div>
  //                 )}
  //               </div>

  //               {urgentActive && (
  //                 <div className="w-full flex justify-center my-2 shrink-0">
  //                   <div className="inline-flex items-center justify-center gap-3 bg-red-500 text-white px-4 py-2 rounded-full shadow-md border border-red-600">
  //                     <span className="font-semibold text-xs sm:text-sm whitespace-nowrap">
  //                       Wait for agent response
  //                     </span>

  //                     <div className="flex items-center justify-center px-2 py-0.5 bg-white text-red-500 rounded-full font-bold text-xs sm:text-sm">
  //                       {urgentTimeLeft}s
  //                     </div>
  //                   </div>
  //                 </div>
  //               )}
  //             </div>

  //             <div className="flex items-center gap-2 mx-2 sm:mx-4 mb-2 border border-gray-300 px-2 py-1 rounded-lg shrink-0 min-w-0">
  //               <div className="shrink-0">
  //                 <Uploader
  //                   imageUrl={imageUrl}
  //                   setImageUrl={setImageUrl}
  //                   name_merge="Employee"
  //                   folder="chat"
  //                   chatId={chatId}
  //                   senderId={id_employee}
  //                   receiverId={agentId}
  //                   senderName={senderName}
  //                   setMessages={
  //                     setMessages
  //                   }
  //                   receiverName={
  //                     receiverName
  //                   }
  //                 />
  //               </div>

  //               <input
  //                 type="text"
  //                 value={input}
  //                 maxLength={1000}
  //                 onChange={(e) => {
  //                   setInput(e.target.value);
  //                   handleTyping();
  //                 }}
  //                 onKeyDown={(e) =>
  //                   e.key === "Enter" &&
  //                   sendMessage()
  //                 }
  //                 placeholder="Type a message..."
  //                 className="flex-1 min-w-0 p-1 rounded-lg bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
  //               />
  //               <button
  //                 onClick={sendMessage}
  //                 className="shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out transform hover:scale-105"
  //               >
  //                 <IoSendSharp className="text-green-500 hover:text-green-600 m-0 p-0" size={24} />
  //               </button>
  //             </div>
  //           </div>

  //           {isOnline && (
  //             <div
  //               className="w-full lg:w-1/4 bg-white rounded-lg shadow-lg p-3 sm:p-4 overflow-y-auto min-w-0"
  //               style={{
  //                 height: "auto",
  //                 maxHeight: "calc(100dvh - 180px)",
  //                 minHeight: "250px",
  //               }}
  //             >
  //               <div className="mb-4">
  //                 <SelectSingleState
  //                   stateId={stateId}
  //                   onChange={(e) => {
  //                     const selectedState =
  //                       e.target.value;

  //                     setStateId(
  //                       selectedState
  //                     );

  //                     localStorage.setItem(
  //                       "stateId",
  //                       selectedState
  //                     );
  //                   }}
  //                 />
  //               </div>

  //               <h3 className="text-sm font-bold mb-2">
  //                 Employees:
  //               </h3>

  //               <div className="space-y-1">
  //                 {users.map((user) => (
  //                   <button
  //                     key={user.id}
  //                     style={{
  //                       backgroundColor:
  //                         user.is_online
  //                           ? "#7BE569"
  //                           : "#6B7280",
  //                     }}
  //                     className="p-2 text-white rounded-lg w-full text-left hover:opacity-90 transition-opacity flex items-center justify-between gap-2"
  //                     onClick={() => {
  //                       if (
  //                         user.is_online &&
  //                         user.chat_status ===
  //                         "Unassigned"
  //                       ) {
  //                         setOpenTransferModal(
  //                           true
  //                         );
  //                         setSelectedEmp(
  //                           user
  //                         );
  //                       }
  //                     }}
  //                   >
  //                     <span className="truncate min-w-0">
  //                       {user.name}
  //                     </span>

  //                     <span
  //                       className={`shrink-0 text-xs px-2 py-1 rounded-lg ${user.chat_status ===
  //                         "Unassigned"
  //                         ? "bg-white text-black"
  //                         : "bg-red-600 text-white"
  //                         }`}
  //                     >
  //                       {user.chat_status ===
  //                         "Unassigned"
  //                         ? "Available"
  //                         : "Busy"}
  //                     </span>
  //                   </button>
  //                 ))}
  //                 {users?.length == 0 && <span className="w-full text-gray-500 text-xs sm:text-sm">No Employee available</span>}
  //               </div>
  //             </div>
  //           )}
  //         </div>
  //       </div>
  //     ) : (
  //       <>
  //         {profile === "User" ? (
  //           isOnline &&
  //           showChat && (
  //             <div
  //               className="w-full sm:w-1/2 lg:w-1/4 ml-auto mt-4 bg-white rounded-lg shadow-lg p-4 overflow-y-auto"
  //               style={{
  //                 height: "auto",
  //                 maxHeight: "calc(100dvh - 180px)",
  //                 minHeight: "250px",
  //               }}
  //             >
  //               <h3 className="text-sm font-bold mb-2">
  //                 Employees:
  //               </h3>

  //               <div className="space-y-1">
  //                 {users.map((user) => (
  //                   <button
  //                     key={user.id}
  //                     style={{
  //                       backgroundColor:
  //                         user.is_online
  //                           ? "#7BE569"
  //                           : "#6B7280",
  //                     }}
  //                     className="p-2 text-white rounded-lg w-full hover:opacity-90 flex items-center justify-between gap-2"
  //                     onClick={() => {
  //                       if (
  //                         user.is_online &&
  //                         user.chat_status ===
  //                         "Unassigned"
  //                       ) {
  //                         setOpenTransferModal(
  //                           true
  //                         );
  //                         setSelectedEmp(
  //                           user
  //                         );
  //                       }
  //                     }}
  //                   >
  //                     <span className="truncate">
  //                       {user.name}
  //                     </span>

  //                     <span className="text-xs shrink-0 bg-white text-black px-2 py-1 rounded-lg">
  //                       {user.chat_status}
  //                     </span>
  //                   </button>
  //                 ))}
  //                 {users?.length == 0 && <span className="w-full text-gray-500 text-xs sm:text-sm">No Employee available</span>}
  //               </div>
  //             </div>
  //           )
  //         ) : (
  //           <>
  //             <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
  //               <CardItemTwo
  //                 mode={mode}
  //                 currency={currency}
  //                 title="Today Order"
  //                 title2="TodayOrder"
  //                 Icon={ImStack}
  //                 cash={todayCashPayment || 0}
  //                 card={todayCardPayment || 0}
  //                 credit={todayCreditPayment || 0}
  //                 price={todayOrderAmount || 0}
  //                 className="text-white dark:text-green-100 bg-teal-500"
  //                 loading={loadingOrderAmount}
  //               />

  //               <CardItemTwo
  //                 mode={mode}
  //                 currency={currency}
  //                 title="Yesterday Order"
  //                 title2="YesterdayOrder"
  //                 Icon={ImStack}
  //                 cash={yesterdayCashPayment || 0}
  //                 card={yesterdayCardPayment || 0}
  //                 credit={yesterdayCreditPayment || 0}
  //                 price={yesterdayOrderAmount || 0}
  //                 className="text-white dark:text-orange-100 bg-orange-400"
  //                 loading={loadingOrderAmount}
  //               />

  //               <CardItemTwo
  //                 mode={mode}
  //                 currency={currency}
  //                 title2="ThisMonth"
  //                 Icon={FiShoppingCart}
  //                 price={dashboardOrderAmount?.thisMonthlyOrderAmount || 0}
  //                 className="text-white dark:text-green-100 bg-blue-500"
  //                 loading={loadingOrderAmount}
  //               />

  //               <CardItemTwo
  //                 mode={mode}
  //                 currency={currency}
  //                 title2="AllTimeSales"
  //                 Icon={ImCreditCard}
  //                 price={dashboardOrderAmount?.totalAmount || 0}
  //                 className="text-white dark:text-green-100 bg-green-500"
  //                 loading={loadingOrderAmount}
  //               />
  //             </div>

  //             <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
  //               <CardItem
  //                 title="Total Order"
  //                 Icon={FiShoppingCart}
  //                 loading={loadingOrderCount}
  //                 quantity={dashboardOrderCount?.totalOrder || 0}
  //                 className="text-orange-600 dark:text-orange-100 bg-orange-100 dark:bg-orange-500"
  //               />

  //               <CardItem
  //                 title={t("OrderPending")}
  //                 Icon={FiRefreshCw}
  //                 loading={loadingOrderCount}
  //                 quantity={dashboardOrderCount?.totalPendingOrder?.count || 0}
  //                 amount={dashboardOrderCount?.totalPendingOrder?.total || 0}
  //                 className="text-blue-600 dark:text-blue-100 bg-blue-100 dark:bg-blue-500"
  //               />

  //               <CardItem
  //                 title={t("OrderProcessing")}
  //                 Icon={FiTruck}
  //                 loading={loadingOrderCount}
  //                 quantity={dashboardOrderCount?.totalProcessingOrder || 0}
  //                 className="text-teal-600 dark:text-teal-100 bg-teal-100 dark:bg-teal-500"
  //               />

  //               <CardItem
  //                 title={t("OrderDelivered")}
  //                 Icon={FiCheck}
  //                 loading={loadingOrderCount}
  //                 quantity={dashboardOrderCount?.totalDeliveredOrder || 0}
  //                 className="text-green-600 dark:text-green-100 bg-green-100 dark:bg-green-500"
  //               />
  //             </div>
  //           </>
  //         )}
  //       </>
  //     )}
  //           {showChat && (
  //       <Modal
  //         className="relative bg-white p-4 sm:p-5 w-[calc(100%-2rem)] sm:w-full sm:max-w-md overflow-hidden rounded-md"
  //         isOpen={openTransferModal}
  //         onClose={() =>
  //           setOpenTransferModal(false)
  //         }
  //       >
  //         <div className="mb-4 pb-2 text-sm sm:text-base break-words">
  //           Transfer chat to{" "}
  //           <span className="font-semibold">
  //             {selectedEmp?.name}
  //           </span>{" "}
  //           ?
  //         </div>

  //         <div className="flex flex-col sm:flex-row gap-2">
  //           <Button
  //             layout="outline"
  //             className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
  //             onClick={() =>
  //               transferChat(
  //                 selectedEmp
  //               )
  //             }
  //           >
  //             Yes
  //           </Button>

  //           <Button
  //             layout="outline"
  //             className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
  //             onClick={() =>
  //               setOpenTransferModal(false)
  //             }
  //           >
  //             No
  //           </Button>
  //         </div>
  //       </Modal>
  //     )}

  //     {showChat && (
  //       <Modal
  //         className="relative bg-white p-4 sm:p-5 w-[calc(100%-2rem)] sm:w-full sm:max-w-md overflow-hidden rounded-md"
  //         isOpen={confirmAction !== null}
  //         onClose={() => setConfirmAction(null)}
  //       >
  //         <div className="mb-4 pb-2 text-sm sm:text-base break-words">
  //           {confirmAction === "alert"
  //             ? "Send an urgent alert to the agent?"
  //             : "Are you sure you want to end this chat?"}
  //         </div>

  //         <div className="flex flex-col sm:flex-row gap-2">
  //           <Button
  //             layout="outline"
  //             className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
  //             onClick={handleConfirm}
  //           >
  //             Yes
  //           </Button>

  //           <Button
  //             layout="outline"
  //             className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
  //             onClick={() => setConfirmAction(null)}
  //           >
  //             No
  //           </Button>
  //         </div>
  //       </Modal>
  //     )}
  //   </>
  // );

return (
  <>
    <PageTitle sidebar={sidebar} />

    {showChat === true ? (
      <div className="w-full min-w-0 max-w-full overflow-x-hidden px-2 sm:px-4 pb-4">
        <div className="flex flex-col lg:flex-row w-full min-w-0 max-w-full gap-4">
          <div
            className="flex flex-col text-gray-900 w-full lg:w-3/4 lg:flex-none min-w-0 max-w-full bg-white rounded-lg shadow-lg border border-gray-300 overflow-hidden"
            style={{
              height: "calc(100dvh - 180px)",
              minHeight: "500px",
            }}
          >
            <div className="flex items-center justify-between gap-2 px-2 sm:px-4 py-3 text-sm border-b border-gray-100 shrink-0 min-w-0 max-w-full">
              <div className="min-w-0 flex-1 pr-1">
                <div className="text-gray-700 leading-5 break-words [overflow-wrap:anywhere]">
                  Chat with Agent{" "}
                  <span className="font-bold break-words [overflow-wrap:anywhere]">
                    {receiverName} [{agentRefId}]
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2 sm:gap-3 shrink-0">
                <button
                  onClick={() => setConfirmAction("alert")}
                  title="Alert"
                  className="h-8 w-8 sm:h-auto sm:w-auto sm:py-1 sm:px-3 text-red-700 border border-red-700 rounded-lg font-semibold flex items-center justify-center gap-1.5 hover:bg-red-50 transition-colors"
                >
                  <TbBellRingingFilled className="inline sm:hidden text-lg" />
                  <span className="hidden sm:inline">Alert</span>
                </button>

                <button
                  onClick={() => setConfirmAction("end")}
                  title="End Chat"
                  className="h-8 w-8 sm:h-auto sm:w-auto sm:py-1 sm:px-3 text-red-700 border border-red-700 rounded-lg font-semibold flex items-center justify-center gap-1.5 hover:bg-red-50 transition-colors"
                >
                  <RxCross2 className="inline sm:hidden text-lg" />
                  <span className="hidden sm:inline">End Chat</span>
                </button>
              </div>
            </div>

            <div className="relative flex-1 min-h-0 min-w-0 w-full max-w-full px-2 sm:px-4 my-2 flex flex-col overflow-hidden">
              <div
                ref={messagesContainerRef}
                style={{
                  scrollbarWidth: "thin",
                  overflowAnchor: "none",
                }}
                className="flex-1 min-h-0 min-w-0 w-full max-w-full border border-gray-300 p-2 sm:p-3 overflow-y-auto overflow-x-hidden rounded-lg bg-gray-100"
              >
                {messages.map((msg, index) => {
                  const adminInfo = JSON.parse(
                    localStorage.getItem("adminInfo") || "null"
                  );

                  const isMe =
                    msg.senderId === adminInfo?.id ||
                    msg.sender === "Me" ||
                    msg.sender === adminInfo?.name;

                  return (
                    <div
                      key={index}
                      className={`w-full min-w-0 max-w-full p-2 my-1 flex ${
                        isMe ? "justify-end" : "justify-start"
                      }`}
                    >
                      <div
                        className={`flex min-w-0 max-w-full items-start gap-2 sm:gap-3 ${
                          isMe ? "flex-row" : "flex-row"
                        }`}
                      >
                        {!isMe && (
                          <div className="shrink-0">
                            {msg.sender ? (
                              <div className="w-8 h-8 border border-gray-600 rounded-full bg-gray-200 flex items-center justify-center">
                                <span className="text-sm font-bold text-gray-600">
                                  {msg.sender.trim().charAt(0).toUpperCase()}
                                </span>
                              </div>
                            ) : (
                              <BiSolidUserCircle
                                size={32}
                                className="text-gray-500"
                              />
                            )}
                          </div>
                        )}

                        <div className="flex-1 min-w-0 max-w-full">
                          <div
                            className={`text-xs mb-1 break-words [overflow-wrap:anywhere] ${
                              isMe ? "text-green-500" : "text-gray-400"
                            }`}
                          >
                            {isMe ? "Me" : msg.sender}
                          </div>

                          <div
                            className={`inline-block w-fit min-w-0 max-w-full rounded-lg p-2 break-words whitespace-pre-wrap [overflow-wrap:anywhere] ${
                              isMe
                                ? "bg-green-500 text-white"
                                : "bg-gray-300 text-black"
                            }`}
                          >
                            {msg.type === "text" && (
                              <span className="block min-w-0 max-w-full whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
                                {msg.text}
                              </span>
                            )}

                            {msg.type === "image" && (
                              <img
                                src={msg.text}
                                alt="Sent"
                                className="block mt-2 h-auto max-w-full rounded-lg object-contain"
                                style={{
                                  maxHeight: "300px",
                                }}
                              />
                            )}

                            {msg.type === "pdf" && (
                              <a
                                href={msg.text}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block max-w-full"
                              >
                                <img
                                  width="100"
                                  height="100"
                                  className="block h-auto max-w-full"
                                  src="https://www.freeiconspng.com/thumbs/pdf-icon-png/pdf-icon-png-pdf-zum-download-2.png"
                                  alt="PDF Preview"
                                />
                              </a>
                            )}
                          </div>

                          <div className="text-xs text-gray-400 mt-1">
                            {msg.time && !isNaN(new Date(msg.time))
                              ? new Date(msg.time).toLocaleTimeString(
                                  "en-GB",
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  }
                                )
                              : "Invalid Date"}
                          </div>
                        </div>

                        {isMe && (
                          <div className="shrink-0">
                            {msg.sender ? (
                              <div className="w-8 h-8 border border-green-600 rounded-full bg-green-100 flex items-center justify-center">
                                <span className="text-sm font-bold text-green-600">
                                  {msg.sender.trim().charAt(0).toUpperCase()}
                                </span>
                              </div>
                            ) : (
                              <BiSolidUserCircle
                                size={32}
                                className="text-green-500"
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                {typingUser && (
                  <div className="flex items-center gap-1 text-sm text-gray-500 px-2 py-2 min-w-0 max-w-full">
                    <span className="break-words [overflow-wrap:anywhere]">
                      {typingUser} is typing
                    </span>

                    <span className="inline-flex items-center gap-1 shrink-0">
                      <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" />
                      <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:150ms]" />
                      <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:300ms]" />
                    </span>
                  </div>
                )}
              </div>

              {urgentActive && (
                <div className="w-full min-w-0 flex justify-center my-2 shrink-0">
                  <div className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-red-500 text-white px-3 sm:px-4 py-2 rounded-full shadow-md border border-red-600 max-w-full">
                    <span className="font-semibold text-xs sm:text-sm">
                      Wait for agent response
                    </span>

                    <div className="flex shrink-0 items-center justify-center px-2 py-0.5 bg-white text-red-500 rounded-full font-bold text-xs sm:text-sm">
                      {urgentTimeLeft}s
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex items-center gap-2 mx-2 sm:mx-4 mb-2 border border-gray-300 px-2 py-1 rounded-lg shrink-0 min-w-0 max-w-[calc(100%-1rem)] overflow-hidden">
              <div className="shrink-0">
                <Uploader
                  imageUrl={imageUrl}
                  setImageUrl={setImageUrl}
                  name_merge="Employee"
                  folder="chat"
                  chatId={chatId}
                  senderId={id_employee}
                  receiverId={agentId}
                  senderName={senderName}
                  setMessages={setMessages}
                  receiverName={receiverName}
                />
              </div>

              <input
                type="text"
                value={input}
                maxLength={1000}
                onChange={(e) => {
                  setInput(e.target.value);
                  handleTyping();
                }}
                onKeyDown={(e) =>
                  e.key === "Enter" && sendMessage()
                }
                placeholder="Type a message..."
                className="flex-1 min-w-0 w-full p-1 rounded-lg bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              <button
                onClick={sendMessage}
                className="shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out transform hover:scale-105"
              >
                <IoSendSharp
                  className="text-green-500 hover:text-green-600 m-0 p-0"
                  size={24}
                />
              </button>
            </div>
          </div>

          {isOnline && (
            <div
              className="w-full lg:w-1/4 lg:flex-1 bg-white border border-gray-300 rounded-lg shadow-lg p-3 sm:p-4 overflow-y-auto overflow-x-hidden min-w-0 max-w-full"
              style={{
                height: "auto",
                maxHeight: "calc(100dvh - 180px)",
                minHeight: "250px",
              }}
            >
              <div className="mb-4">
                <SelectSingleState
                  stateId={stateId}
                  onChange={(e) => {
                    const selectedState = e.target.value;
                    setStateId(selectedState);
                    localStorage.setItem("stateId", selectedState);
                  }}
                />
              </div>

              <h3 className="text-sm font-bold mb-2">
                Employees:
              </h3>

              <div className="space-y-1">
                {users.map((user) => (
                  <button
                    key={user.id}
                    style={{
                      backgroundColor: user.is_online
                        ? "#7BE569"
                        : "#6B7280",
                    }}
                    className="p-2 text-white rounded-lg w-full text-left hover:opacity-90 transition-opacity flex items-center justify-between gap-2 min-w-0"
                    onClick={() => {
                      if (
                        user.is_online &&
                        user.chat_status === "Unassigned"
                      ) {
                        setOpenTransferModal(true);
                        setSelectedEmp(user);
                      }
                    }}
                  >
                    <span className="truncate min-w-0">
                      {user.name}
                    </span>

                    <span
                      className={`shrink-0 text-xs px-2 py-1 rounded-lg ${
                        user.chat_status === "Unassigned"
                          ? "bg-white text-black"
                          : "bg-red-600 text-white"
                      }`}
                    >
                      {user.chat_status === "Unassigned"
                        ? "Available"
                        : "Busy"}
                    </span>
                  </button>
                ))}

                {users?.length === 0 && (
                  <span className="block w-full text-gray-500 text-xs sm:text-sm">
                    No Employee available
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    ) : (
      <>
        {profile === "User" ? (
          isOnline &&
          showChat && (
            <div
              className="w-full sm:w-1/2 lg:w-1/4 ml-auto mt-4 bg-white rounded-lg shadow-lg p-4 overflow-y-auto overflow-x-hidden min-w-0 max-w-full"
              style={{
                height: "auto",
                maxHeight: "calc(100dvh - 180px)",
                minHeight: "250px",
              }}
            >
              <h3 className="text-sm font-bold mb-2">
                Employees:
              </h3>

              <div className="space-y-1">
                {users.map((user) => (
                  <button
                    key={user.id}
                    style={{
                      backgroundColor: user.is_online
                        ? "#7BE569"
                        : "#6B7280",
                    }}
                    className="p-2 text-white rounded-lg w-full hover:opacity-90 flex items-center justify-between gap-2 min-w-0"
                    onClick={() => {
                      if (
                        user.is_online &&
                        user.chat_status === "Unassigned"
                      ) {
                        setOpenTransferModal(true);
                        setSelectedEmp(user);
                      }
                    }}
                  >
                    <span className="truncate min-w-0">
                      {user.name}
                    </span>

                    <span className="text-xs shrink-0 bg-white text-black px-2 py-1 rounded-lg">
                      {user.chat_status}
                    </span>
                  </button>
                ))}

                {users?.length === 0 && (
                  <span className="block w-full text-gray-500 text-xs sm:text-sm">
                    No Employee available
                  </span>
                )}
              </div>
            </div>
          )
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
              <CardItemTwo
                mode={mode}
                currency={currency}
                title="Today Order"
                title2="TodayOrder"
                Icon={ImStack}
                cash={todayCashPayment || 0}
                card={todayCardPayment || 0}
                credit={todayCreditPayment || 0}
                price={todayOrderAmount || 0}
                className="text-white dark:text-green-100 bg-teal-500"
                loading={loadingOrderAmount}
              />

              <CardItemTwo
                mode={mode}
                currency={currency}
                title="Yesterday Order"
                title2="YesterdayOrder"
                Icon={ImStack}
                cash={yesterdayCashPayment || 0}
                card={yesterdayCardPayment || 0}
                credit={yesterdayCreditPayment || 0}
                price={yesterdayOrderAmount || 0}
                className="text-white dark:text-orange-100 bg-orange-400"
                loading={loadingOrderAmount}
              />

              <CardItemTwo
                mode={mode}
                currency={currency}
                title2="ThisMonth"
                Icon={FiShoppingCart}
                price={dashboardOrderAmount?.thisMonthlyOrderAmount || 0}
                className="text-white dark:text-green-100 bg-blue-500"
                loading={loadingOrderAmount}
              />

              <CardItemTwo
                mode={mode}
                currency={currency}
                title2="AllTimeSales"
                Icon={ImCreditCard}
                price={dashboardOrderAmount?.totalAmount || 0}
                className="text-white dark:text-green-100 bg-green-500"
                loading={loadingOrderAmount}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
              <CardItem
                title="Total Order"
                Icon={FiShoppingCart}
                loading={loadingOrderCount}
                quantity={dashboardOrderCount?.totalOrder || 0}
                className="text-orange-600 dark:text-orange-100 bg-orange-100 dark:bg-orange-500"
              />

              <CardItem
                title={t("OrderPending")}
                Icon={FiRefreshCw}
                loading={loadingOrderCount}
                quantity={dashboardOrderCount?.totalPendingOrder?.count || 0}
                amount={dashboardOrderCount?.totalPendingOrder?.total || 0}
                className="text-blue-600 dark:text-blue-100 bg-blue-100 dark:bg-blue-500"
              />

              <CardItem
                title={t("OrderProcessing")}
                Icon={FiTruck}
                loading={loadingOrderCount}
                quantity={dashboardOrderCount?.totalProcessingOrder || 0}
                className="text-teal-600 dark:text-teal-100 bg-teal-100 dark:bg-teal-500"
              />

              <CardItem
                title={t("OrderDelivered")}
                Icon={FiCheck}
                loading={loadingOrderCount}
                quantity={dashboardOrderCount?.totalDeliveredOrder || 0}
                className="text-green-600 dark:text-green-100 bg-green-100 dark:bg-green-500"
              />
            </div>
          </>
        )}
      </>
    )}

    {showChat && (
      <Modal
        className="relative bg-white p-4 sm:p-5 w-[calc(100%-2rem)] sm:w-full sm:max-w-md overflow-hidden rounded-md"
        isOpen={openTransferModal}
        onClose={() => setOpenTransferModal(false)}
      >
        <div className="mb-4 pb-2 text-sm sm:text-base break-words">
          Transfer chat to{" "}
          <span className="font-semibold">
            {selectedEmp?.name}
          </span>{" "}
          ?
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            layout="outline"
            className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
            onClick={() => transferChat(selectedEmp)}
          >
            Yes
          </Button>

          <Button
            layout="outline"
            className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
            onClick={() => setOpenTransferModal(false)}
          >
            No
          </Button>
        </div>
      </Modal>
    )}

    {showChat && (
      <Modal
        className="relative bg-white p-4 sm:p-5 w-[calc(100%-2rem)] sm:w-full sm:max-w-md overflow-hidden rounded-md"
        isOpen={confirmAction !== null}
        onClose={() => setConfirmAction(null)}
      >
        <div className="mb-4 pb-2 text-sm sm:text-base break-words">
          {confirmAction === "alert"
            ? "Send an urgent alert to the agent?"
            : "Are you sure you want to end this chat?"}
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            layout="outline"
            className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
            onClick={handleConfirm}
          >
            Yes
          </Button>

          <Button
            layout="outline"
            className="w-full sm:w-auto hover:bg-gray-100 hover:border-gray-500"
            onClick={() => setConfirmAction(null)}
          >
            No
          </Button>
        </div>
      </Modal>
    )}
  </>
);
};

export default Dashboard;